import React from 'react';
import { useMediaQuery } from 'react-responsive';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import BreadCrumbComponent from '@components/obsolete/BreadCrumbComponent/BreadCrumbComponent.tsx';
import { CalendarLayoutManagement } from '@components/features/calendar-layout/management/CalendarLayoutManagement';

interface ComponentProps {}

/**
 * Customer-facing calendar layout settings: the company's own models, the system-wide ones it can
 * start from, and which of its locations render what.
 *
 * Shares `CalendarLayoutManagement` with the admin tool — the backend narrows everything to the
 * caller's company, and `admin={false}` drops the affordances that would only 403.
 */
const CalendarLayoutSettings: React.FC<ComponentProps> = () => {
  const { tr } = useTranslationLgs();
  const isMobile = useMediaQuery({ maxWidth: 1024 });

  return (
    <>
      {!isMobile && <BreadCrumbComponent items={[{ label: tr('CalendarLayout.breadCrumb', 'Calendar card layouts') }]} />}
      <CalendarLayoutManagement admin={false} title={tr('CalendarLayout.pageTitle', 'Calendar card layouts')} />
    </>
  );
};

export default CalendarLayoutSettings;
